/**
 * Module-scope i18next bootstrap for Portal.
 *
 * This module is a side-effect entry point: it must be imported exactly
 * once, as the first import in `index.tsx`, before React starts rendering.
 * Never import it from a component, hook, or test — importing it anywhere
 * else risks a second `i18next.init()` call or drags the real
 * `i18next-http-backend` (network fetches) into the test graph.
 */
import { THEME_IDS } from '@whistler-ui/k2/constants/global';
import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { SETTINGS } from './constants';
import { isThemeId, resolveBrandConfig } from './store/theme/brands';

i18next.use(initReactI18next).use(HttpApi);

if (!i18next.isInitialized) {
  const resolvedThemeId = isThemeId(SETTINGS.THEME_ID)
    ? SETTINGS.THEME_ID
    : THEME_IDS.NETLYNC;

  const {
    productName,
    companyName,
    productFullName,
    portalFullName,
    saasFullName,
    supportEmail,
  } = resolveBrandConfig(resolvedThemeId).i18n.variables;

  i18next.init({
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    contextSeparator: ':::',
    debug: import.meta.env.REACT_APP_I18N_DEBUG || false,
    defaultNS: 'translation',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        productName,
        companyName,
        productFullName,
        portalFullName,
        saasFullName,
        supportEmail,
      },
    },
    lng: 'en',
    ns: ['translation', 'pages', 'components', 'common', 'modules'],
    partialBundledLanguages: true,
  });
}

export default i18next;
